import {useContext} from 'react';
import {DebugModeContext} from './DebugModeProvider';

const useIsDebugMode = () => {
  const {debugMode} = useContext(DebugModeContext);
  return debugMode;
};

export default useIsDebugMode;
